import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

type HeaderLogoProps = {
  logo: JSX.Element;
};

export const HeaderLogo = ({ logo }: HeaderLogoProps) => {
  const { t } = useTranslation();

  return (
    <Link href="/" aria-label={t("common:common_home")}>{logo}</Link>
  );
};
